/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAlertSmall = createReactComponent("outline", "alert-small", "IconAlertSmall", [["path", { "d": "M12 8v4", "key": "svg-0" }], ["path", { "d": "M12 16h.01", "key": "svg-1" }]]);

export { IconAlertSmall as default };
//# sourceMappingURL=IconAlertSmall.mjs.map
